export const CloseConsultationIcon = ({ className }: { className?: string }) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_4973_98409)">
        <path
          d="M39.9999 34.6664C38.5253 34.6664 37.3334 35.8613 37.3334 37.3329V47.9999C37.3334 49.4691 36.1386 50.6664 34.6664 50.6664H26.6665V10.6665C26.6665 8.38914 25.2158 6.35448 23.0346 5.59716L22.2451 5.333H34.6664C36.1386 5.333 37.3334 6.53026 37.3334 7.99998V16C37.3334 17.4716 38.5253 18.6665 39.9999 18.6665C41.4745 18.6665 42.6664 17.4716 42.6664 16V7.99998C42.6664 3.58935 39.0771 0 34.6664 0H5.99999C5.89843 0 5.81347 0.0454101 5.71483 0.0585936C5.58642 0.0478515 5.46386 0 5.33349 0C2.39209 0 0 2.3916 0 5.333V53.3329C0 55.6102 1.45068 57.6449 3.63183 58.4022L19.6801 63.7518C20.2241 63.9198 20.7651 63.9999 21.3335 63.9999C24.2749 63.9999 26.6665 61.6078 26.6665 58.6664V55.9999H34.6664C39.0771 55.9999 42.6664 52.4105 42.6664 47.9999V37.3329C42.6664 35.8613 41.4745 34.6664 39.9999 34.6664Z"
          fill="currentColor"
        />
        <path
          d="M63.2187 24.7806L52.5517 14.1141C51.7895 13.3514 50.6425 13.1219 49.6455 13.535C48.6509 13.9486 48 14.9217 48 15.9993V23.9993H37.3335C35.8613 23.9993 34.6665 25.1937 34.6665 26.6658C34.6665 28.138 35.8613 29.3323 37.3335 29.3323H48V37.3323C48 38.4099 48.6509 39.3831 49.6455 39.7967C50.6425 40.2097 51.7895 39.9802 52.5517 39.218L63.2187 28.5511C64.2612 27.5086 64.2612 25.823 63.2187 24.7806Z"
          fill="#FF9800"
        />
        <ellipse cx="17.5" cy="30.5" rx="2.5" ry="3.5" fill="black" fillOpacity="0.33" />
      </g>
      <defs>
        <clipPath id="clip0_4973_98409">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
